import { TEXT_BODY, TEXT_MUTED } from '../../lib/medievalTheme';
import { getClass } from '../../utils/arena/classes';
import { t } from '../../localization/t';
import { RushStacks } from './BattlemageGauges';

const ACCENT = getClass('battlemage').accent;
const GOOD = '#8fd3a4';
const BAD = '#e89090';

const signed = (pct) => (pct >= 0 ? `+${pct}%` : `${pct}%`);

function stackLine({ won, guarded, rushBefore, rush, multiplier, spent }) {
  const pct = Math.round((multiplier - 1) * 100);
  if (spent) return { color: GOOD, text: t('Overkill. Rewards {n}, every stack spent.', { n: signed(pct) }) };
  if (won) return { color: GOOD, text: t('Rush of Battle grows to {n}. Rewards {p}.', { n: rush, p: signed(pct) }) };
  if (guarded) return { color: TEXT_BODY, text: t('Your pledge held the stacks. Rewards {p}.', { p: signed(pct) }) };
  if (rushBefore > 0) return { color: BAD, text: t('Defeat. Every stack lost.') };
  return null;
}

// The settled standing on the match result screen: what the stacks did to
// the reward, and the Ferocity banked.
export default function BattlemageResult({ battlemage }) {
  const { rush, rushMax, ferocity, ferocityMax, ferocityGained, flawless, overflowGold } = battlemage;
  const line = stackLine(battlemage);
  return (
    <div
      className="match-result-plate flex flex-col mb-3 rounded-lg"
      style={{ padding: '0.5cqw 0.75cqw', gap: '0.375cqw', fontSize: '0.75cqw', lineHeight: 1.35 }}
      data-testid="battlemage-result"
    >
      <div className="flex items-center justify-between">
        <span className="arena-heading" style={{ color: ACCENT, fontSize: '0.875cqw' }}>{t('The rush')}</span>
        <span className="flex items-center" style={{ gap: '0.5cqw' }}>
          <RushStacks rush={rush} max={rushMax} size={0.55} />
          <span className="arena-heading tabular-nums" style={{ color: rush > 0 ? ACCENT : TEXT_MUTED }}>{rushMax == null ? rush : `${rush} / ${rushMax}`}</span>
        </span>
      </div>
      {line ? <div style={{ color: line.color }}>{line.text}</div> : null}
      {ferocityMax > 0 ? (
        <div style={{ color: TEXT_BODY }}>
          <span className="tabular-nums" style={{ color: TEXT_MUTED }}>{t('Ferocity {n} / {max}', { n: ferocity, max: ferocityMax })}</span>
          {ferocityGained > 0 ? <span style={{ color: GOOD }}> +{ferocityGained}</span> : null}
          {flawless && ferocityGained > 0 ? ` ${t('Flawless. Ferocity doubled.')}` : ''}
          {overflowGold > 0 ? ` ${t('Overflow: +{n} Gold.', { n: overflowGold })}` : ''}
        </div>
      ) : null}
    </div>
  );
}
